import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const StyledFlex = styled(Flex)`
  height: 100vh;
  padding: 0px 40px;
  text-align: center;
`;

export const StyledReloadButton = styled(Button)`
  margin-top: 1rem;
`;
